@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.paidDescription {
  @include t.text(14px, 22px, 400);
  color: v.$palette-gray-900;
  margin: 0px auto 24px;
}

.payDescription {
  @include t.text(14px, 22px, 400);
  color: v.$palette-gray-900;
  margin-bottom: 24px;
}

.freeDescription {
  @include t.text(14px, 22px, 400);
  color: v.$palette-gray-900;
  margin-bottom: 24px;
}

.freeDescriptionText {
  margin-bottom: 16px;
}

.descriptionLink {
  @include t.text(14px, 22px, 600);
  color: v.$palette-blue;
  padding: 0;
}